import React from "react";
import ReactDOMServer from "react-dom/server";
import MailReviewStep from "components/MailTemplate";
import { typeOf } from "services/utils.service";

export function generateHtmlEmail(formData) {
  return ReactDOMServer.renderToStaticMarkup(
    <MailReviewStep allStepsFormData={formData} />
  );
}

export function extractAttachments(stepData) {
  const fileRegexp = /^data:/;
  function extract(acc, [key, value]) {
    const typeOfValue = typeOf(value);
    switch (typeOfValue) {
      case "string":
        if (fileRegexp.test(value)) {
          acc.push(value);
          return acc;
        } else {
          return acc;
        }
      case "object":
        return Object.entries(value).reduce(extract, acc);
      case "array":
        return Object.entries(value).reduce(extract, acc);
      default:
        return acc;
    }
  }
  return Object.entries(stepData).reduce(extract, []);
}
